import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=4abe8be6&scoped=true&"
var script = {}
import style0 from "./Pro.vue?vue&type=style&index=0&id=4abe8be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe8be6",
  null
  
)

export default component.exports